import type { ContentModelText } from '~/models/Content/ContentModelText'
import type { ContentImageCollection } from '~/models/Content/ContentImageCollection'
import type { ContentFlytTask } from '~/models/Content/ContentFlytTask'
import type { ContentFlashcardDeck } from '~/models/Content/ContentFlashcards'
import type { ContentArticleTabs } from '~/models/Content/ContentArticleTabs'
import type { ColorTheme } from '~/models/Content/Color'
import type { BaseItem } from '~/models/Content/BaseItem'
import type { RelationField, RelationsField, TaxonomyField } from '~/models/Content/BaseField'
import type { ArticleContent } from '~/models/Content/ArticleContent'
import type { TTSLanguage } from '~/models/Brikke/TextToSpeech'
import { ContentType } from '~/models/Content/ContentType'

export type ArticleSize = 'medium' | 'large' | 'xlarge'

export type ArticleHeaderVariation = 'simple' | 'color' | 'text_and_image' | 'text_on_image' | 'none' | 'left_column'

export const ArticleContentTypeCriterion = [
  ContentType.ArticleContent,
  ContentType.ArticleTabs,
  ContentType.ImageCollection,
  ContentType.FlytTask,
  ContentType.Flashcards,
  ContentType.ModelText,
  ContentType.Image,
  ContentType.Svg,
  ContentType.Lottie,
  ContentType.Video,
  ContentType.Scene,
  ContentType.Chatbot,
  ContentType.CodeEditor,
  ContentType.FormWriter,
  ContentType.Conversation,
  ContentType.Sequence,
]

export type ArticleContentTypes = ArticleContent
  | ContentArticleTabs
  | ContentImageCollection
  | ContentFlytTask
  | ContentFlashcardDeck
  | ContentModelText

export interface ContentArticle extends BaseItem {
  overline?: string
  intro: string
  body: string
  wordlist: string[]
  size: TaxonomyField<ArticleSize>
  image?: RelationField
  authors?: RelationsField
  content?: RelationsField
  asideOpen: boolean
  asideContent?: RelationsField
  articles?: RelationsField
  colorTheme: TaxonomyField<ColorTheme>
  headerVariation: TaxonomyField<ArticleHeaderVariation>
  studentGuide: string
  teacherContent?: RelationField
  textToSpeech: boolean
  textToSpeechLanguage: TaxonomyField<TTSLanguage>
}
